/**
 * Date Behavior System
 * 
 * Handles showing/hiding blocks based on date ranges with three modes:
 * - ongoing: No date restrictions (always visible)
 * - seasonal: Show during seasonal periods that may span years (no specific year)
 * - one-time: Show between specific start and end dates (with years)
 */

{
  function isInRange(element){
    const currentDate = new Date();
    const startDate = new Date(element.getAttribute('data-start-date'));
    startDate.setHours(0,0,0,0);
    const endDate = new Date(element.getAttribute('data-end-date'));
    endDate.setHours(23,59,59,999);


    if(/\d{4}/.test(element.getAttribute('data-start-date')) === false){
      startDate.setFullYear(currentDate.getFullYear())
    }

    if(/\d{4}/.test(element.getAttribute('data-end-date')) === false){
      endDate.setFullYear(currentDate.getFullYear())
    }

    if(/\d{4}/.test(element.getAttribute('data-end-date')) === false && endDate < startDate){
      endDate.setFullYear(endDate.getFullYear() + 1)
    }

    return currentDate >= startDate && currentDate <= endDate;
  }

  function maybeHide(element){
    if(!isInRange(element)){
      element.style.display = 'none'
    }
  }
  /**
   * Process all elements with date behavior
   */
  function processDateBehavior() {
    document.querySelectorAll('[class*="wp-block-"][data-start-date]').forEach(element => {
      maybeHide(element)
    })
  }

  //start it up boiiiiii
  processDateBehavior()
}